import styled, { css } from 'styled-components';
import { DoubleRightArrow } from 'components/icons-new/double-right-arrow';
import { Flex } from 'common/common-components.styled';

interface StyledSideMenuProps {
  isMinimized: boolean;
  open: boolean;
  isDesktop: boolean;
}

const Drawer = styled.div<{ isMinimized: boolean }>`
  width: 100%;
  max-width: ${({ isMinimized }) => (isMinimized ? '65px' : '300px')};
  will-change: max-width;
  transition: max-width ${({ theme }) => theme.transition.duration.short}ms
    ${({ theme }) => theme.transition.easing.easeInOut};
`;

export const SideMenuActionBarContainer = styled(Drawer)`
  position: fixed;
  bottom: 0;
  z-index: ${({ theme }) => theme.sidebar.zIndex + 1};
`;

export const StyledSideMenu = styled(Drawer)<StyledSideMenuProps>`
  display: flex;
  flex-direction: column;
  background-color: #fff;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.25);
  height: auto;
  z-index: ${({ theme }) => theme.sidebar.zIndex};
  overflow: hidden;

  ${({ isDesktop, open }) =>
    !isDesktop &&
    css`
      transform: translateX(${open ? '0px' : '-300px'});
      position: fixed;
      top: 0;
      bottom: 0;
    `};
`;

interface StyledDoubleRightArrowProps {
  isMinimized: boolean;
}

export const StyledDoubleRightArrow = styled(DoubleRightArrow)<StyledDoubleRightArrowProps>`
  transform: rotate(${({ isMinimized }) => (isMinimized ? '0deg' : '180deg')});
`;

export const StyledHeader = styled(Flex)<{ isMinimized: boolean }>`
  justify-content: ${({ isMinimized }) => (isMinimized ? 'center' : 'initial')};
  align-items: center;
  padding: ${({ isMinimized }) => (isMinimized ? '0 15px' : '0 20px')};
  min-height: 60px;
  background: ${({ theme }) => theme.colors.blue};
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.08);
`;

export const StyledActions = styled(Flex)`
  position: relative;
  background-color: ${({ theme }) => theme.colors.white};
  z-index: 1301;
`;

export const ScrollbarContainer = styled.div<{ actionBarHeight: number; isDesktopWidth: boolean }>`
  padding-bottom: ${({ actionBarHeight, isDesktopWidth }) => (isDesktopWidth ? actionBarHeight : 0)}px;
`;
